import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const CC = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [period, setPeriod] = useState(10);
  const [longPeriod, setLongPeriod] = useState(11);
  const [shortPeriod, setShortPeriod] = useState(14);
  const [color, setColor] = useState("AA2211");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);
  const [height, setHeight] = useState("1");
  const [value, setValue] = useState(
    period + "," + longPeriod + "," + shortPeriod
  );

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.CC_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      props.onTAValueChange({
        ta: "CC",
        name: `${t("chart5.TA.CC")} (CC)`,
        option: {
          period: localChartSetting.option.period,
          longPeriod: localChartSetting.option.longPeriod,
          shortPeriod: localChartSetting.option.shortPeriod,
          color: localChartSetting.option.color,
          thickness: localChartSetting.option.thickness,
          style: localChartSetting.option.style,
          showTracker: localChartSetting.option.showTracker,
          height: localChartSetting.option.height,
        },
        value: localChartSetting.value,
      });
    }
  }, [localChartSetting]);

  useEffect(() => {
    const CC = props.localChartSetting.CC_Option
    setPeriod(parseInt(CC.option.period) || period);
    setLongPeriod(parseInt(CC.option.longPeriod) || longPeriod);
    setShortPeriod(parseInt(CC.option.shortPeriod) || shortPeriod);
    setColor(CC.option.color);
    setThickness(parseInt(CC.option.thickness) || thickness);
    setStyle(CC.option.style);
    setShowTracker(CC.option.showTracker);
    setHeight(CC.option.height);
  }, [props.localChartSetting]);

  useEffect(() => {
    setValue(period + "," + longPeriod + "," + shortPeriod);
    props.onTAValueChange({
      ta: "CC",
      name: `${t("chart5.TA.CC")} (CC)`,
      option: {
        period: period,
        longPeriod: longPeriod,
        shortPeriod: shortPeriod,
        color: color,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
        height: height,
      },
      value: value,
    });
  }, [
    period,
    longPeriod,
    shortPeriod,
    color,
    thickness,
    style,
    showTracker,
    height,
  ]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const CC = props.localChartSetting.CC_Option
    setPeriod(parseInt(CC.option.period) || period);
    setLongPeriod(parseInt(CC.option.longPeriod) || longPeriod);
    setShortPeriod(parseInt(CC.option.shortPeriod) || shortPeriod);
    setColor(CC.option.color);
    setThickness(parseInt(CC.option.thickness) || thickness);
    setStyle(CC.option.style);
    setShowTracker(CC.option.showTracker);
    setHeight(CC.option.height);
  }, [props.isReset]);

  const resetALL = () => {
    setPeriod(10);
    setLongPeriod(11);
    setShortPeriod(14);
    setColor("AA2211");
    setThickness(2);
    setStyle("s");
    setShowTracker(true);
    setHeight("1");
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicalindicator" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeTA = (id) => {
    props.removeTA(id);
  };

  // e: any, type: string
  const onPeriodChange = (e, type) => {
    switch (type) {
      case "period":
        setPeriod(e.target.value);
        break;
      case "long":
        setLongPeriod(e.target.value);
        break;
      case "short":
        setShortPeriod(e.target.value);
        break;
    }
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "CC":
        setColor(props.selectedColor);
        break;
    }
  };

  const onColorClick = () => {
    props.onColorClick(color, "CC", t("chart5.setting"));
  };

  const onKeyDown = (evt) => {
    if (evt.key === "-") evt.preventDefault();
  };

  return (
    <div
      className="menusubitem msiaction techicalindicator"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeTA("CC")}></div> */}
      <div className="box-container">
        <span className="span">
          {t("chart5.TA.CC")} (CC) {value}
        </span>
        <IconCloseLight className="close-icon" onClick={() => removeTA("CC")} />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="menusubitem " id="msi-ta-CC">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.period")}</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-CC-p0-period0"
                type="number"
                step="1"
                min="1"
                value={period}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "period")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>

          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-CC-p0-color0"
              className="colorpicker"
              value={color}
              style={{ backgroundColor: "#" + color }}
              onClick={onColorClick}
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-CC-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-CC-p0-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-CC-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>
        <div className="menusubitem " id="msi-ta-CC">
          <div className="flexbox">
            <div className="taparamlbl">
              {t("chart5.short")} {t("chart5.period")}
            </div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-CC-p1-period0"
                type="number"
                step="1"
                min="1"
                value={longPeriod}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "long")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>
        </div>

        <div className="menusubitem " id="msi-ta-CC">
          <div className="flexbox">
            <div className="taparamlbl">
              {t("chart5.long")} {t("chart5.period")}
            </div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-CC-p2-period0"
                type="number"
                step="1"
                min="1"
                value={shortPeriod}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "short")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>
        </div>

        <div className="menusubitem" id="msi-ta-CC">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.displayScreenSize")}</div>
            <div className="selectbox taparam">
              <select
                id="msi-ta-CC-ps-h"
                value={height}
                onChange={(e) => onHeightChange(e)}
              >
                <option value="2">{t("chart5.large")}</option>
                <option value="1">{t("chart5.normal")}</option>
                <option value="0">{t("chart5.small")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
